import React from 'react';
import { Td } from './styles';
import { Tr } from '../styles';

function TableRows({
  data,
  columns,
  columnsModify,
  columnButtons,
  columnsStyles,
}) {
  return (
    <Tr>
      {columns.map((col, index) =>
        Object.keys(columnsModify).includes(col) ? (
          <Td key={index} style={columnsStyles[col] && columnsStyles[col]}>
            {columnsModify[col](data[col])}
          </Td>
        ) : (
          <Td key={index} style={columnsStyles[col] && columnsStyles[col]}>
            {data[col]}
          </Td>
        ),
      )}
      {columnButtons.map((button, i) => (
        <Td key={i}>{button(data)}</Td>
      ))}
    </Tr>
  );
}

export default React.memo(TableRows);
